module.exports = __webpack_public_path__ + "img/Logo.3535f99a.svg";